import React from "react";

const AverageReservationsNormalization = ({ row }) => {
  return (
    <div>
      {row?.reservationsAverage
        ? row?.reservationsAverage?.toLocaleString()
        : 0}
    </div>
  );
};

export default AverageReservationsNormalization;
